import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useTranslation from 'hooks/useTranslations'

const Greeting = props => {
  const { user } = props

  const t = useTranslation()

  return (
    <Box mb={4}>
      <Typography variant="h1" gutterBottom>
        {t('home:title')}
      </Typography>
      <Typography variant="body1">{user}</Typography>
    </Box>
  )
}

Greeting.propTypes = {
  user: PropTypes.any,
}

export default Greeting
